import { FirebaseAuth } from "../../components/FirebaseAuth/firebase";
import { signOut } from "firebase/auth";
import { log, SIGN_IN, SIGN_OUT, UPDATE_USERNAME } from '../log';
import { clearMfaSessionVerified } from "../mfa";
import { ModularAuth } from "../../components/FirebaseAuth/firebase";

export const userSignIn = (callback) => {
    log(SIGN_IN, () => {});
    callback(true);
}

export const userSignOut = () => {
    log(SIGN_OUT, () => {});
    clearMfaSessionVerified(ModularAuth.currentUser?.uid);
    signOut(ModularAuth);
}

export const userUpdateName = async () => {
    const Firestore = FirebaseAuth.firestore();
    const currentUser = ModularAuth.currentUser;

    if (!currentUser) return false;

    const userDocRef = Firestore.collection('users').doc(currentUser.uid);
    for (let attempt = 0; attempt < 20; attempt += 1) {
        try {
            const snapshot = await userDocRef.get();
            if (snapshot.exists) {
                await userDocRef.set({
                    display_name: currentUser.displayName,
                    updated_at: new Date(),
                }, {merge: true});
                log(UPDATE_USERNAME);
                return true;
            }
        } catch (_error) {
            // Retry while the Auth user-creation trigger creates the Firestore user document.
        }
        await new Promise((resolve) => setTimeout(resolve, 250));
    }
    return false;
}
